export default {
    setAuthorData(state: any, newData: any) {
        state.foto = newData.foto;
        state.name = newData.name;
        state.company_name = newData.company_name;
        state.description = newData.description;
        state.donasi = newData.donasi;
        state.contacts = newData.contacts;
    }
};
